/** percent already on 0..100 scale (14 = +14%), not ratio 0.14 */
export const formatPayoutPercent = (percent: number): string => {
  if (!Number.isFinite(percent)) return "0";
  const rounded = Math.round(percent * 100) / 100;
  return rounded.toFixed(2).replace(/\.?0+$/, "");
};
